import PackageTypesSection from "components/staff/WebsiteUpdates/PackageTypesSection";

const StaffPackageTypes = () => {
    return <div style={{ padding: '20px' }}>
        <PackageTypesSection
            readOnly={true}
        />
    </div>;
}

export default StaffPackageTypes;